export default __webpack_public_path__ + "static/media/aldamaeats.12dc69fb.png";